import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {Paper,Grid,Box,Card} from '@material-ui/core/';
import GoogleMap from "./Map";
import {FlexibleXYPlot, FlexibleWidthXYPlot,FlexibleHeightXYPlot,XAxis, YAxis, HorizontalGridLines, LineSeries} from 'react-vis';
import Sidenav from "./Sidenav";
import Table from "./Table";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding:'20px 0 0 0'
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary
  },
  chartContainer: {
    marginRight: '10px',
  },
}));

export default function FullWidthGrid() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Grid container spacing={3}>
      <Grid item xs={6} sm={3}>
        <Paper className={classes.paper}>KPI A</Paper>
      </Grid>
      <Grid item xs={6} sm={3}>
        <Paper className={classes.paper}>KPI B</Paper>
      </Grid>
      <Grid item xs={6} sm={3}>
        <Paper className={classes.paper}>KPI C</Paper>
      </Grid>
      <Grid item xs={6} sm={3}>
        <Paper className={classes.paper}>KPI D</Paper>
      </Grid>
      <Grid item xs={12} sm={12}>
      <Box m={2}>
        <Table size="small" / >
      </Box>
      </Grid>
        <Grid item xs={12} sm={6}>
        <GoogleMap/>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Card className={classes.chartContainer}>
          <FlexibleXYPlot height={280} style={{margin: '0 50dp 0 0'}}>
            <HorizontalGridLines />
            <LineSeries
              data={[
                {x: 1, y: 10},
                {x: 2, y: 5},
                {x: 3, y: 15}
              ]}/>
            <XAxis />
            <YAxis />
          </FlexibleXYPlot>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
}
